module.exports = __webpack_public_path__ + "img/fluent_phone-tablet-20-regular.89dfb94d.svg";